// extracted by mini-css-extract-plugin
export default {"searchNav":"Search_searchNav__UYEMo","searchInput":"Search_searchInput__tyuqx"};